.page {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  width: 100%;
  background:
    radial-gradient(ellipse 60% 45% at 50% 30%, var(--color-primary-soft), transparent 70%),
    var(--color-background);
}

.inline {
  min-height: 100%;
  background: none;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 4rem 1rem;
  text-align: center;
}

.art {
  width: min(28rem, 100%);
  margin-bottom: 0.5rem;
}

.title {
  max-width: 36rem;
  text-wrap: balance;
}

.body {
  max-width: 32rem;
  display: grid;
  gap: 0.75rem;
  color: var(--color-muted);
  text-wrap: pretty;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.75rem;
  margin-top: 1rem;
}

.footer {
  padding: 2.5rem;
}

